import React, {
  useEffect,
  useContext,
  useImperativeHandle,
  forwardRef,
} from "react";
import AppContext from "../../contexts/appContext";
import SwitchLgpd from "../SwitchLgpd/SwitchLgpd";
import { useInputState } from "../../hooks";

const ContactWay = (_, ref) => {
  const context = useContext(AppContext);
  const [consent, setConsent] = useInputState(context.lgpdConsent || "");

  useEffect(() => {
    context.setContext({
      ...context,
      lgpdConsent: consent.value,
    });
  }, [consent]);

  const setConsentChange = (value) => ({
    invalid: false,
    value,
  });

  useImperativeHandle(
    ref,
    () => ({
      validate: () => {
        if (consent.value !== "1" && consent.value !== "0") {
          const state = {
            invalid: true,
            value: consent.value,
          };
          setConsent({
            ...state,
            ...consent,
            errorMessage: "Campo obrigatório",
          });
          return state;
        }

        setConsent({ ...consent });
        context.setContext({
          ...context,
          lgpdConsent: consent.value,
        });
        return setConsentChange(consent.value);
      },
    }),
    [consent, context, setConsent]
  );

  const handleInputChange = (setter) => (value) => {
    setter(value);
  };

  return (
    <SwitchLgpd
      type={consent.value}
      error={consent.errorMessage}
      onChange={handleInputChange(setConsent)}
    />
  );
};

export default forwardRef(ContactWay);
